import { LoadingService } from './../../../../util/loader.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Component, Injector, OnInit } from '@angular/core';
import { NotificacaoService } from '../notificacao.service';
import { Notificacao } from '../../../../models/notificacao/notificacao';
import { DatepickerOptions } from 'ng2-datepicker';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
const moment = require('moment');
const swal = require('sweetalert');

@Component({
  selector: 'app-auxiliar-notificacao',
  templateUrl: './auxiliar-notificacao.component.html',
  styleUrls: ['./auxiliar-notificacao.component.scss']
})
export class AuxiliarNotificacaoComponent implements OnInit {
  buttonType;
  valForm: FormGroup;
  notificacao: Notificacao;
  filterPublicoAlvo: any = false;
  quantidadePublicoAlvo: number;
  quantidadeUsuario: number;

  itemUsuario: Array<any>;
  publicoAlvoText: string;
  publicoAlvo: Array<any>;

  usuarioText: string;
  usuarios: Array<any>;
  itemsPublicoAlvo: Array<any>;
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();

  public radioModel = 'Todos';
  public searchTyped = new BehaviorSubject('');
  public maskdata: Array<string | RegExp>;
  public relogio: any;
  public totalSegmento = null;
  public maskhora: Array<string | RegExp>;
  public listEmojiSmileys: Array<any>;
  constructor(
    public service: NotificacaoService,
    public injector: Injector,
    fb: FormBuilder,
    private route: ActivatedRoute,
    private routerNavigate: Router,
    public loader: LoadingService,
    private _localeService: BsLocaleService,
  ) {
    this.notificacao = new Notificacao();
    this.maskdata = [
      /[0-3]/,
      /\d/,
      '/',
      /[0-1]/,
      /\d/,
      '/',
      /2/,
      /\d/,
      /\d/,
      /\d/,
      ' ',
      /[0-2]/,
      /\d/,
      ':',
      /[0-5]/,
      /\d/
    ];
    this.maskhora = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];
    this.valForm = fb.group({
      'notificacaoTitulo': [null, Validators.required],
      'notificacaoMensagem': [null, Validators.required],
      //  'notificacaoDataExpiracao': [null, null],
      'notificacaoPublicoAlvoFilter': [null, null],
      'notificacaoPublicoAlvo': [null, null],
      'notificacaoUsuario': [null, Validators.required],
      'notificacaoAgendamento': [null, null],
      'dataAgendamento': [null, null],
      'hora': [null, null],

    });
    this.valForm.controls['dataAgendamento'].disable();
    this.valForm.controls['hora'].disable();
    this._localeService.use('pt');
    this.obterUsuario();
    this.relogio = new Date();
    setInterval(() => {
      this.relogio = new Date();
      // console.log(this.relogio); // just testing if it is working
    }, 5000);
  }

  publicoAlvoSelecionado(event) {
    this.itemsPublicoAlvo.forEach(e => {
      if (e.id_segmento_notificacao === event) {
        if (this.publicoAlvoText == null) {
          this.publicoAlvoText = e.nome + ';';
        } else {
          this.publicoAlvoText += e.nome + ';';
        }
      }
    });
    const item = this.itemsPublicoAlvo.find(item => item.id_segmento_notificacao === event);
    this.service.totalSegmento(item.referencia).subscribe(result => {
      this.totalSegmento = result.total;
    });
  }

  usuarioSelecionado(event) {
    this.itemUsuario.forEach(e => {
      if (e.id_usuarios === event) {
        if (this.usuarioText === null) {
          this.usuarioText = e.nome + ';';
        } else {
          this.usuarioText += e.nome + ';';
        }
      }
    });
  }

  usuarioRemovido(event) {
    this.itemUsuario.forEach(e => {
      if (e.id_usuarios === event) {
        this.usuarioText = this.usuarioText.replace(e.nome + ';', '');
      }
    });

    if (this.usuarioText.trim() === '') {
      this.quantidadeUsuario = null;
      this.usuarios = null;
    }
  }
  publicoAlvoRemovido(event) {
    this.itemsPublicoAlvo.forEach(e => {
      if (e.codigo === event) {
        this.publicoAlvoText = this.publicoAlvoText.replace(e.nome + ';', '');
      }
    });

    if (this.publicoAlvoText.trim() === '') {
      this.quantidadePublicoAlvo = null;
      this.publicoAlvo = null;
    }
  }

  obterUsuario() {
    this.service.listarUsuarios('').subscribe(result => {
      this.itemUsuario = result;
    });
  }

  agendar(agendarEnvio) {
    if (this.notificacao.agendamento) {
      this.valForm.controls['dataAgendamento'].enable();
      this.valForm.controls['dataAgendamento'].setValidators([Validators.required]);
      this.valForm.controls["dataAgendamento"].updateValueAndValidity();


      this.valForm.controls['hora'].enable();
      this.valForm.controls['hora'].setValidators([Validators.required]);
      this.valForm.controls["hora"].updateValueAndValidity();
    } else {
      this.valForm.controls["dataAgendamento"].clearValidators();
      this.valForm.controls["dataAgendamento"].updateValueAndValidity();
      this.valForm.controls['dataAgendamento'].disable();
      this.valForm.controls["dataAgendamento"].setValue(null);

      this.valForm.controls["hora"].clearValidators();
      this.valForm.controls["hora"].updateValueAndValidity();
      this.valForm.controls['hora'].disable();
      this.valForm.controls["hora"].setValue(null);
    }
  }
  filtroPublicoAlvo() {
    this.radioModel = 'Todos';

    if (this.filterPublicoAlvo == true) {

      //this.valForm.controls['emailUsuario'].disable();
      this.notificacao.usuarios = [];
      this.valForm.controls['notificacaoUsuario'].setValue(null);
      this.valForm.controls['notificacaoUsuario'].disable();

      this.valForm.controls['notificacaoPublicoAlvo'].setValidators([Validators.required]);
      this.valForm.controls["notificacaoPublicoAlvo"].updateValueAndValidity();

      this.valForm.controls["notificacaoUsuario"].clearValidators();
      this.valForm.controls["notificacaoUsuario"].updateValueAndValidity();

    } else {
      this.valForm.controls['notificacaoUsuario'].enable();
      this.notificacao.publicoAlvo = null;
      this.valForm.controls['notificacaoUsuario'].setValidators([Validators.required]);
      this.valForm.controls["notificacaoUsuario"].updateValueAndValidity();
      this.valForm.controls["notificacaoPublicoAlvo"].clearValidators();
      this.valForm.controls["notificacaoPublicoAlvo"].updateValueAndValidity();


      // this.valForm.controls['emailUsuario'].enable();
    }

    this.service.obterPublicoAlvo().subscribe(result => {
      this.itemsPublicoAlvo = result;
    });
  }

  inicializarCombos() {
    this.filterPublicoAlvo = false;
    this.publicoAlvoText = null;
    this.publicoAlvo = null;

    this.usuarioText = null;
    this.usuarios = null;
  }
  existefiltroPublicoAlvo() {
    if (this.filterPublicoAlvo) {
      return true;
    }
    return false;
  }

  validarDados() {
    if (this.usuarioText === '' && this.publicoAlvoText === '') {
      swal(
        'Atenção',
        'Você precisa selecionar um usuário para enviar notificações.',
        'warning'
      );
      return false;
    }
    return true;
  }

  submitForm($ev, value: any, buttonType: string) {
    $ev.preventDefault();
    for (const c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      this.loader.show('body');
      if (this.validarDados()) {

        if (this.notificacao.agendamento) {
          /* const data = moment(this.notificacao.dataAgendamento);
           const hora = `${this.notificacao.hora}:00`.split(':');
           let utcTime = moment.utc(`${this.notificacao.hora}:00`);
           let utcDate = moment.utc(this.notificacao.dataAgendamento);
           const calculatedDateString = moment(`${utcDate.format('YYYY-MM-DD')} ${utcTime.format("HH:mm:ss z")}`);
           let dateValue = moment({
             year: data.year(),
             month: data.month(),
             day: data.date(),
             hour: hora[0],
             minute: hora[1],
             second: 0
           }).toDate();
           this.notificacao.dataAgendamento = new Date(calculatedDateString);*/
          //const hora = `${this.notificacao.hora}:00`.split(':');
          // this.notificacao.dataAgendamento = moment(new Date(this.notificacao.dataAgendamento.setHours(Number(hora[0]), Number(hora[1]), Number(hora[2])))).utc();
          debugger;
        }
        this.notificacao.hora = `${this.notificacao.hora}:00`.split(':');
        debugger;
        /* if (this.publicoAlvo != null) {
           this.notificacao.PublicoAlvoAux = this.publicoAlvo.toString();
         }

         if (this.usuarios != null) {
           this.notificacao.UsuariosDestino = this.usuarios.toString();
         }*/

        this.service.inserirNotificacao(this.notificacao).subscribe(result => {
          this.loader.hide('body');
          this.callbackSave(result);
        });
      } else {
        this.loader.hide('body');
      }
    }
  }

  callbackSave(result) {
    if (result == true) {
      swal('Atenção', 'Ação realizada com sucesso.', 'success');
      this.valForm.reset();
      this.routerNavigate.navigate(['/fidel/notificacao']);
    }
  }
  addEmoji($event) {
    let data = this.valForm.get('notificacaoMensagem');
    data.patchValue(data.value + $event.emoji.native);
  }
  loadEmoji() {
    this.listEmojiSmileys = ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '☺️', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', ' 😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩', '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓', '🤗', '🤔', '🤭', '🤫', '🤥', '😶', '😐', '😑', '😬', '🙄', '😯', '😦', '😧', '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '🤐', '🥴', '🤢', '🤮', '🤧', '😷', '🤒', '🤕', '🤑', '🤠', '😈', '👿', '👹', '👺', '🤡', '💩', '👻', '💀', '☠️', '👽', '👾', '🤖', '🎃', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾'];
  }
  ngOnInit() { }
}
